var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.percentComplete)?_c('section',{staticClass:"quiz-progress-bar",class:{ thin: _vm.thin }},[_c('div',{staticClass:"bar",style:(_vm.barStyles)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }